import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Intro from "../../components/intro";
import { fetchTripDetail } from "../../utils/tripsApi";
import { TripDetail } from "../../components/trip/types";
import TripTopBar from "../../components/trip/topBar";
import TripItinerary from "../../components/trip/itinerary";
import TripBudgetSection from "../../components/trip/budget";
import TripSites from "../../components/trip/sites";
import TripChecklistSection from "../../components/trip/checklist";
import TripBuddies from "../../components/trip/buddies";
import { getTripBuddies } from "../../components/trip/utils";
import "../../components/trip/style.css";

const TripDetails = () => {
  const { id: tripId } = useParams();
  const [trip, setTrip] = useState<TripDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!tripId) return;

    let cancelled = false;

    const loadTrip = async () => {
      setLoading(true);
      setError("");
      try {
        const detail = await fetchTripDetail(tripId);
        if (cancelled) return;
        setTrip(detail);
      } catch (err) {
        if (cancelled) return;
        setTrip(null);
        setError(err instanceof Error ? err.message : "Something went wrong");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadTrip();

    return () => {
      cancelled = true;
    };
  }, [tripId]);

  return (
    <div className="trip-page">
      <Intro />
      <TripTopBar label={trip?.itinerary?.country || "Trip"} />
      <div className="trip-page-inner">
        {loading && <div className="trip-status">Loading trip...</div>}
        {!loading && error && (
          <div className="trip-status trip-status-error">{error}</div>
        )}
        {!loading && trip && (
          <>
            <TripItinerary trip={trip} />
            <TripBudgetSection
              budget={trip.tripBudget}
              fallbackTotal={trip.totalBudget}
            />
            <TripSites site={trip.site} />
            <TripChecklistSection checklist={trip.checklist} />
            <TripBuddies buddies={getTripBuddies(trip)} />
          </>
        )}
      </div>
    </div>
  );
};

export default TripDetails;
